/**
 * shared/src/schemas/ws.schema.ts
 *
 * FASE 8 — Zod schemas per messaggi WebSocket.
 * Uniforma la validazione dei messaggi WS con quella REST (già Zod-based).
 * Sostituisce le validazioni `typeof` manuali in liveRideServer.ts.
 */
import { z } from 'zod';
// ─── Auth Message ───────────────────────────────────────────────────────────
export const WsAuthMessageSchema = z.object({
    type: z.literal('auth'),
    token: z.string().min(1, 'Token JWT richiesto'),
});
// ─── Join Message ───────────────────────────────────────────────────────────
export const WsJoinMessageSchema = z.object({
    type: z.literal('join'),
    sessionId: z.string().uuid('sessionId deve essere un UUID valido'),
});
// ─── Position Message ───────────────────────────────────────────────────────
export const WsPositionMessageSchema = z.object({
    type: z.literal('position'),
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    speed: z.number().min(0).max(400).default(0),
    heading: z.number().min(0).max(360).default(0),
    batteryPct: z.number().min(0).max(100).optional(),
});
// ─── Leave Message ──────────────────────────────────────────────────────────
export const WsLeaveMessageSchema = z.object({
    type: z.literal('leave'),
});
// ─── Ping/Pong ──────────────────────────────────────────────────────────────
export const WsPingMessageSchema = z.object({
    type: z.literal('ping'),
});
// ─── Discriminated Union ────────────────────────────────────────────────────
export const WsClientMessageSchema = z.discriminatedUnion('type', [
    WsAuthMessageSchema,
    WsJoinMessageSchema,
    WsPositionMessageSchema,
    WsLeaveMessageSchema,
    WsPingMessageSchema,
]);
/**
 * Valida un messaggio WebSocket ricevuto dal client.
 * Ritorna il messaggio parsed o un errore descrittivo.
 */
export function parseWsMessage(raw) {
    const result = WsClientMessageSchema.safeParse(raw);
    if (result.success) {
        return { success: true, message: result.data };
    }
    return { success: false, error: result.error.issues.map(i => i.message).join('; ') };
}
//# sourceMappingURL=ws.schema.js.map